import { Component, OnInit, ViewChild } from '@angular/core';
import {MatPaginator as MatPaginator, PageEvent as PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.css']
})
export class EmailTemplateComponent implements OnInit {

  displayedColumns: string[] = ['Id', 'Subject', 'EmailType', 'Actions'];
  @ViewChild(MatPaginator,{static:true}) paginator: MatPaginator;
  dataSource = new MatTableDataSource<any>([]);
  emailList: any[] = [];
  totalLength: any[] = [];
  filterForm: any = { searchValue: '', pageSize: 10, pageNo: 0, emailTemplateSort: null };
  @ViewChild(MatSort,{static:true}) sort: MatSort;


  constructor(private httpClient: HttpClient, private snotifyService: ToastrService) {

   }

  ngOnInit() {
    this.dataSource = new MatTableDataSource([]);
    this.dataSource.sort = this.sort;
    this.getTemplates()  
  }
 
  getTemplates() {
    this.httpClient.post(`/EmailTemplate/GetAllEmailTemplate`,this.filterForm).subscribe((res: any) => {
      this.emailList = res.list;
       this.dataSource = new MatTableDataSource(res.list);
      this.totalLength = res.totalCount;
    });
  }
  public sortTemplets(event) {
    this.filterForm.emailTemplateSort = {
      SortField: event.active,
      SortType: event.direction ? event.direction : 'asc'
    }
    this.getTemplates();
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  public changePage(event: PageEvent) {
    this.filterForm.pageNo = event.pageIndex;
    this.filterForm.pageSize = event.pageSize;
    this.getTemplates();
  }
  delete(id) {
    id=id.toString()
       this.httpClient.delete(`/EmailTemplate/DeleteTemplate/${id}`).subscribe((res: any) => {
      this.snotifyService.success("", "Template deleted successfully", {
        timeOut: 2500,
        progressBar: true,
          
         tapToDismiss : true 
      });
      this.getTemplates()
    });
  }
}
